"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Handles information about a total price.
 */
var TotalPriceModel =
/**
 * Class constructor.
 */
function TotalPriceModel() {
  _classCallCheck(this, TotalPriceModel);

  this.normal = 0;
  this.normalExclTax = 0;
  this.family = 0;
  this.familyExclTax = 0;
  this.regular = 0;
  this.regularExclTax = 0;
  this.isOnlineSellable = true;
  this.isNew = true;
  this.isFamily = false;
  this.isTemporary = false;
  this.validDateInterval = null;
  this.ecoPrice = 0;
  this.weeePrice = 0;
};

exports.default = TotalPriceModel;